<template>
  <span
    :class="[
      'text-xs font-semibold text-center uppercase inline-flex items-center',
      {
        'rounded-md p-2 justify-center': display == 'full',
      },
      {
        'bg-success/20 text-green-600': (status == BUDGET_ITEM_STATUS.ACCEPTED && display != 'text'),
        'bg-info/20 text-info': (status == BUDGET_ITEM_STATUS.SCHEDULED && display != 'text'),
        'bg-warning/20 text-warning': (status == BUDGET_ITEM_STATUS.IN_PROGRESS && display != 'text'),
        'bg-error/20 text-error': (status == BUDGET_ITEM_STATUS.ON_HOLD && display != 'text'),
        'bg-success/50 text-green-900': (status == BUDGET_ITEM_STATUS.COMPLETED && display != 'text'),
        'bg-slate-100 text-slate-800': (!status || status === '' && display != 'text')
      }
    ]"
  >
    <span v-if="display == 'stripe'" class="h-full min-h-10 min-w-1">&nbsp;</span>
    <span v-if="display == 'dot'" class="rounded-full size-2">&nbsp;</span>
    <span
      v-else-if="display == 'full' || display == 'text'"
      :class="[
        'sm:truncate',
        {
          'text-green-600': status == BUDGET_ITEM_STATUS.ACCEPTED,
          'text-info': status == BUDGET_ITEM_STATUS.SCHEDULED,
          'text-warning': status == BUDGET_ITEM_STATUS.IN_PROGRESS,
          'text-error': status == BUDGET_ITEM_STATUS.ON_HOLD,
          'text-green-900': status == BUDGET_ITEM_STATUS.COMPLETED,
          'text-slate-800': !status || status === ''
        }
      ]"
    >
      {{
        status == BUDGET_ITEM_STATUS.ACCEPTED ? 'Accepted' :
        status == BUDGET_ITEM_STATUS.SCHEDULED ? 'Scheduled' :
        status == BUDGET_ITEM_STATUS.IN_PROGRESS ? 'In Progress' :
        status == BUDGET_ITEM_STATUS.ON_HOLD ? 'On Hold' :
        status == BUDGET_ITEM_STATUS.COMPLETED ? 'Completed' :
        'Not Set'
      }}
    </span>
  </span>
</template>

<script lang="ts" setup>
import { PropType } from 'vue'
import { BUDGET_ITEM_STATUS } from '@/models/budget'

defineProps({
  status: {
    type: String,
    required: false,
    default: ''
  },
  display: {
    type: String as PropType<'text' | 'dot' | 'stripe' | 'full'>,
    default: 'full'
  },
  colorOnly: {
    type: Boolean,
    default: false
  },
  statusDot: {
    type: Boolean,
    default: false
  }
})
</script>
